import { PlanFamily, PlanKind } from 'src/types';
import classNames from 'classnames';
import { OfferCard } from 'src/v2/pages/subscription/components/CancelSubscription/components/OfferCard';
import styles from './OfferSection.module.scss';
import './OfferSection.scss';
import { UserTier } from 'src/types/wallet/models/UserTier';

interface OfferSectionProps {
  planFamily: PlanFamily;
  onOpenCheckout?: () => void;
  planKindToOffer?: PlanKind;
  planTier?: UserTier;
}

export const OfferSection = ({
  planFamily,
  planKindToOffer,
  onOpenCheckout,
  planTier,
}: OfferSectionProps) => {
  return (
    <div
      className={classNames(styles.root, {
        [styles.highlighted]: planKindToOffer?.includes('30'),
      })}
    >
      <div className={styles.planCardWrapper}>
        <OfferCard
          planFamily={planFamily}
          onOpenCheckout={onOpenCheckout}
          planKindToOffer={planKindToOffer}
          planTier={planTier}
        />
      </div>
    </div>
  );
};
